 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		25: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"npm.quill","2":"npm.react-dom","3":"npm.react-quill","7":"npm.babel","8":"npm.emoji-picker-react","9":"npm.react-dd-menu","10":"npm.react-papaparse","11":"npm.react-player","12":"npm.readable-stream","17":"npm.canvg","18":"npm.create-react-class","19":"npm.d3-scale","20":"npm.dompurify","21":"npm.react-querybuilder","22":"npm.react-smooth","23":"npm.react-sortable-hoc","24":"npm.recharts"}[chunkId]||chunkId) + "." + {"1":"d603068026ac191700d3","2":"0e7c69ea3084e053b6a2","3":"178c407a689716bef2cb","4":"bd6e356416e16e6e78b4","5":"e7491743df260218c519","6":"b60353fe52070d422928","7":"f53aa471d5fd48bd2f25","8":"60e8a3c3d4500ffdf1b4","9":"091a8b7bab5aa73ee718","10":"c474607377a9ed04d054","11":"f51a5adafe29531e67fc","12":"ca130e96103a05dd5f36","13":"68e8f993bfb47825dc81","14":"1b625f3378a9db60bbef","17":"23abe43bec6ee4a4ccb2","18":"4d17f9c1570e999f6e9d","19":"f35c3202dd6e26f0654c","20":"01f21c1fa07c5237801c","21":"5958492da9d50145e70e","22":"8bdea132b417f5b65922","23":"3176a1410e1709acb014","24":"608993608670a53be41c","26":"2a4d8fe098a9ca8ee0d7","27":"d0dde8fb4a75f7bd6a20","28":"02e578c5aa03fbf1cf65","29":"25187f51cf092395697f","30":"26173cb9bbaa30a645c5","31":"9483553201df2e63a6a8","32":"372cc772e8e98f1e3c6f","33":"971fb27204ee3529ab33","34":"bb63f628dcc546d88c6f","35":"6504441a7672b97f3ad6","36":"31b386a0b6ff49d6426e","37":"18a59629a913825a2685","38":"3fbfd8c639d9a2f50607","39":"dc8f83d0f039f87dc5d6","40":"1fdda3e930119e935884","41":"a573a5ae54449394f6e1","42":"97aecd63d51e718d68b4","43":"a27a2170817dea7a19cb","44":"0673b717995c8760decb","45":"561830491e0c0f4b3cb4","46":"ad3e6ad69c352b09d4d5","47":"c5d566e45771840f42ad","48":"c9ea4ac3539c12ce58e2","49":"7b0b5dbca8ba06186e64","50":"be1d6559652f642bdb63","51":"816f409c4319d88598a8","52":"9a69ebade38da5769a45","53":"b9340a5057dcd4ec94fe","54":"4f337875ce92f5a46932","55":"6479f6117fc0fd71d1ae","56":"fd689405d65e49b037be","57":"36f54b95a6b6da60ae43","58":"c1a1a66cc8c2dbf1bd76","59":"6f5767954e2220f22f90","60":"5e44629b6617df5cdb8a","61":"05e338f465a9a0ee5494","62":"5865f0210e83e747be1d","63":"de58bf86672c9aceecad","64":"3623ebc419710d90c04f","65":"5572e8031711275e6e03","66":"bb2562c2a236a5c5c2e0","67":"0eb3ad8e1cf9ed658acb","68":"320b5f7b1b2b0ba98cc7","69":"2739f6e6051514d54bbd","70":"9f61fe21eaa47f460bbd","71":"d73e6988e72940860a4c","72":"362eafd3620901020247","73":"031aeb47afbd29e56c45","74":"f631c28516fd7f3810c3","75":"921a7b1fec4064f9bca9","76":"6c0e6734f13c0637950c","77":"014b6f9a539e520a298b","78":"9d0e7ed4e5745fce730b","79":"18a6c90acd52cbb84a88","80":"61d6524b68718fa5e63e","81":"5cc2305dbc5a794ee0f9","82":"f091432d68a837ce1b85","83":"9a7f807b62ad4881e3aa","84":"a3daf76d4fe018ad1908","85":"6d49177c692aca4aaaa1","86":"d0214f6409d111cd7dc8","87":"a53031d5556684f98db6","88":"7153db492da5b249d188","89":"eda219bda8bc35f0fe93","90":"3be9a8ab6ff04e676545","91":"b98d474a00e2ab0e48d3","92":"acafd6fe58ac7609e5ec"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/1c0b0f0/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
